import pluja from './pluja.svg';
import neu from './neu.svg';
import tempesta from './tempesta.svg';
import calamarsaPedra from './calamarsaPedra.svg';
import vent from './vent.svg';
import estatDelMar from './estatDelMar.svg';
import boiraGebradora from './boiraGebradora.svg';
import plujaGelant from './plujaGelant.svg';
import tornadoManega from './tornadoManega.svg';
import boiraEspessa from './boiraEspessa.svg';
import altres from './altres.svg';


const iconesIndexadesPerIdMeteor = {};

iconesIndexadesPerIdMeteor[1] = pluja;
iconesIndexadesPerIdMeteor[2] = neu;
iconesIndexadesPerIdMeteor[3] = tempesta;
iconesIndexadesPerIdMeteor[4] = calamarsaPedra;
iconesIndexadesPerIdMeteor[5] = vent;
iconesIndexadesPerIdMeteor[6] = estatDelMar;
iconesIndexadesPerIdMeteor[7] = boiraGebradora;
iconesIndexadesPerIdMeteor[8] = plujaGelant;
iconesIndexadesPerIdMeteor[9] = tornadoManega;
iconesIndexadesPerIdMeteor[10] = boiraEspessa;
iconesIndexadesPerIdMeteor[11] = altres;

export default iconesIndexadesPerIdMeteor;


// WEBPACK FOOTER //
// ./src/images/avis/index.js